export default __webpack_public_path__ + "5f7b99ea2feda066c2347151b5b71b1e.png";